import { render, staticRenderFns } from "./FilesIcon.vue?vue&type=template&id=92c5375a&"
import script from "./FilesIcon.vue?vue&type=script&lang=js&"
export * from "./FilesIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports